import styled, { css } from "styled-components";
export const StyledPopup = styled.div`
  top: -10px;
  width: 320px;
  max-width: 325px !important;

  p {
    margin: 0;
  }

  .mapboxgl-popup-content {
    padding: 40px 30px 25px 30px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    background: #FAFAFA;
    overflow-y: auto;
    ${(props) =>
      !props.$showDetails &&
      css`
        border: none;
      `}

      > div {
        display: flex;
        flex-direction: column;
        row-gap: 8px;
      }
  }
  .mapboxgl-popup-close-button {
    line-height: 1;
    top: 10px;
    right: 16px;
    color: var(--color-primary);
    background: none;
    width: auto;
    height: auto;
    padding: 0;
    font-size: 28px;
    font-weight: 400;
  }
  .mapboxgl-popup-tip {
    border-top-color: #FAFAFA;
  }
`;
export const PopupHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  position: relative;
  color: var(--color-primary);

  span {
    font-weight: 400;
  }
`;

export const PopupTitle = styled.h3`
  font-family: var(--font-primary);
  font-weight: bold;
  font-size: 18px;
  line-height: 1.2;
  margin: 0;
`;

export const PopupSubtitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.3;
`;

export const PopupContent = styled.div`
  min-height: 70px;
  max-height: 220px;
  background: #FAFAFA;
  color: var(--color-primary);
  font-size: 16px;
  line-height: 1.3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 8px;

  span {
    font-family: var(--font-primary);
    font-weight: bold;
  }

  a {
    margin-top: 10px;
    color: var(--color-accent);
    font-size: 10px;
    text-transform: uppercase;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    font-weight: 400;
  }
`;

export const PopupContentTitle = styled.h2`
  margin: 0;
  font-size: 16px;
`;
